import {globalContentNavigation} from "@global/global-elements/global-content-navigation/global-content-navigation.js";

const add2breadcrumb = () => {
    /*
     * Haenge Reference-title an Breadcrump
    */
    const breadcrumbElement = document.querySelector('.breadcrumb .breadcrumb__list');
    const referenceTitle = document.querySelector(referenceDetail.overviewORdetail + ' h1').innerText;

    breadcrumbElement.innerHTML += '<li class="breadcrumb__item"><span class="breadcrumb__item--current">' + referenceTitle + '</span></li>';
};

const switchToCategory = (switchToCategory) => {
    const referenceFilter = document.getElementById('reference-filter');
    if (referenceFilter) {

        referenceFilter.querySelector('.filter__body').style.display = '';

        const filterButtons = referenceFilter.querySelectorAll('.filter[data-category]');
        filterButtons.forEach(btn => {
            if (btn.dataset.category === switchToCategory) {
                btn.classList.add('active');
            }
            else {
                btn.classList.remove('active');
            }
        });

        const referenceLists = referenceFilter.parentElement.querySelectorAll('.global-tile__container[data-category]');
        referenceLists.forEach(container => {
            if (container.dataset.category === switchToCategory) {
                container.style.display = 'block';
            }
            else {
                container.style.display = 'none';
            }
        });
    }
};

const makeCategorySelectionWork = () => {
    const referenceFilter = document.getElementById('reference-filter');
    if (referenceFilter) {
        const filterButtons = referenceFilter.querySelectorAll('.filter[data-category]');
        filterButtons.forEach(btn => {
            btn.addEventListener('click', switchToCategory.bind(this, btn.dataset.category));
        });

        if (document.location.hash) {
            const category = document.location.hash.substr(1);
            switchToCategory(decodeURI(category));
        }
    }
};
window.sss = switchToCategory; // Glaub das war nud debugging... ;-)

const referenceDetail = {
    overviewORdetail: '.reference-detail',

    init: () => {
        const _referenceDetail = document.querySelector(referenceDetail.overviewORdetail);
        if (_referenceDetail !== null) {
            add2breadcrumb();
            makeCategorySelectionWork();
        }

        globalContentNavigation({query: "main [data-contentnav] h2"})
    }
};

export { referenceDetail };
